import { ClinicStorageError, IStorageLicenceInfo } from "src/Utils/Hooks/ManageLicenses/useGetStorageLicenceInfo";
import GridViewWithHeaderNode from "src/SharedComponents/GridViewWithHeader/GridViewWithHeaderNode";
import { useEffect, useMemo, useState } from "react";
import './StorageInfo.css'
import { InfoMessageType } from "src/Components/InfoBar/InfoBar";
import { ILicensesInfo, SubscriptionType } from "src/Utils/Hooks/ManageLicenses/useGetLicensesInfo";
import { formatDateString, isValidDateTime } from "src/Utils/DateFormatting/DateFormattter";
import { useTranslation } from "react-i18next";
import ActivateCloudStorage from "../ActivateCloudStorage/ActivateCloudStorage";

type IClinicStorageInfo = {
    clinicId: string;
    storageInfo: IStorageLicenceInfo;
    setInfo: (message: string, type: InfoMessageType) => void;
    updatePageLoader: (load: boolean) => void;
    licensesInfo: ILicensesInfo;
    isSuiteLicense: boolean;
    showPaymentOption: boolean;
    containsSuiteLicense: boolean;
}
const StorageInfo: React.FC<IClinicStorageInfo> = ({ clinicId, storageInfo ,updatePageLoader, setInfo, licensesInfo, isSuiteLicense, showPaymentOption, containsSuiteLicense }) => {
    const { t } = useTranslation();

    const [percentageUsed, setpercentageUsed] = useState<number>();
    const usedClinicStorage = useMemo(() => {
        if (storageInfo?.totalMaxStorageInGb > 0 && storageInfo?.totalAvailableStorageInGb >= 0) {
            var usedStorage = storageInfo.totalMaxStorageInGb - storageInfo.totalAvailableStorageInGb;
            return Math.round((usedStorage) * 10) / 10; // 1 decimal number
        }
        return 0;
    }, [storageInfo]);

    useEffect(() => {
        if (storageInfo && storageInfo.totalMaxStorageInGb > 0) {
            let percenage = (usedClinicStorage / storageInfo.totalMaxStorageInGb) * 100;
            let roudenNUmber = Math.round(percenage * 10) / 10; // 1 decimal number
            setpercentageUsed(roudenNUmber)
        }
        else {
            setpercentageUsed(0);
        }
    }, [storageInfo, usedClinicStorage])

    const isCloudStorageDeactivated = () => {
        return storageInfo.storageError === ClinicStorageError.DEACTIVATED;
    }

    const percentageusedText = `${percentageUsed}%`;
    const isStorageAboutToExceed = () => percentageUsed && percentageUsed > 90 ? true : false;
    const progressbarColor = isStorageAboutToExceed() ? 'red' : 'var(--primary-color)';

     const isSubscriptionCancelled = () => 
        licensesInfo?.clinicPaymentTransactions?.length > 0 &&
        licensesInfo.clinicPaymentTransactions[0].subscriptionType === SubscriptionType.Cancel;

    const disableActivateCloudStorage = isSubscriptionCancelled() || (new Date(storageInfo.licenseEndDate) < new Date());

    return (
        <>
            {storageInfo &&
                <>
                    <GridViewWithHeaderNode title="Cloud Storage" headerNode={
                        !isValidDateTime(storageInfo.licenseEndDate) && 
                        <div className='d-flex justify-content-end'>
                            <span style={{marginRight:'10px'}}>
                                {
                                    <button type="button" className={`btn storage-renew-validity ${new Date(storageInfo.licenseEndDate) < new Date() ? 'expired' : ''}`}>
                                        {`${t('ValidUnil')} ${formatDateString(storageInfo.licenseEndDate)}`}
                                    </button>
                                }
                            </span>
                        </div>
                    }>
                        {
                                <ActivateCloudStorage
                                    clinicId={clinicId}
                                    setInfo={setInfo}
                                    updatePageLoader={updatePageLoader}
                                    isStorageDeactivated={isCloudStorageDeactivated()}
                                    disableActivateCloudStorage={disableActivateCloudStorage}
                                />
                            
                        }

                        <div className="mt-5" style={{ width: '98%', opacity: `${isCloudStorageDeactivated() ? '0.3' : '1'}` }}>
                            <div className="progress " style={{ height: '4px' }}>
                                <div className="progress-bar" role="progressbar"
                                    style={{
                                        width: percentageusedText,
                                        backgroundColor: progressbarColor
                                    }}>
                                </div>
                            </div>
                        </div>

                        <div className="row mt-3 mb-2">
                            <div style={{ width: `${isStorageAboutToExceed() ? '30%' : '85%'}` }}>
                                <span className="storageInfo" style={{opacity: `${isCloudStorageDeactivated() ? '0.3' : '1'}`}}>{percentageusedText} ({usedClinicStorage} GB) in use</span>
                            </div>
                            {isStorageAboutToExceed() &&
                                <div style={{ width: '55%' }}>
                                    <span className="storageInfo" style={{ color: 'red' }}>Data synchronization will be paused when the memory is full.</span>
                                </div>
                            }
                            <div style={{ width: '15%' }}>
                                <span className="float-end storageInfo" style={{opacity: `${isCloudStorageDeactivated() ? '0.3' : '1'}`}}>{storageInfo.totalMaxStorageInGb} GB</span>
                            </div>
                        </div>

                    </GridViewWithHeaderNode>
                </>
            }
        </>
    )
}
export default StorageInfo;